import { render, staticRenderFns } from "./ClipboardSavedToast.vue?vue&type=template&id=478b2e46&scoped=true"
import script from "./ClipboardSavedToast.vue?vue&type=script&lang=js"
export * from "./ClipboardSavedToast.vue?vue&type=script&lang=js"
import style0 from "./ClipboardSavedToast.vue?vue&type=style&index=0&id=478b2e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478b2e46",
  null
  
)

export default component.exports